import React, {useEffect, useState} from "react";
import $ from "jquery";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import {CORNER_SHELVES_POSITIONS, PAN_POSITIONS, SIDE_POSITIONS} from "../../bvSceneComponent/core/constants";
import ActionTypes from "../../../misc/actionTypes";
import {getFeatureIsLocked} from "../../../misc/helpers";
import {changeMessageBoxState, updateCanvasCount} from "../../../actions/actionFunctions";
import {featureInterface} from "../../../interfaces/featureInterface";

const getPositionName = (position) => {
  switch (position) {
    case CORNER_SHELVES_POSITIONS[0]:
    case CORNER_SHELVES_POSITIONS[3]:
      return "modalCheckboxPosition.top"
    case CORNER_SHELVES_POSITIONS[1]:
    case CORNER_SHELVES_POSITIONS[4]:
      return "modalCheckboxPosition.center"
    case CORNER_SHELVES_POSITIONS[2]:
    case CORNER_SHELVES_POSITIONS[5]:
      return "modalCheckboxPosition.bottom"
    case SIDE_POSITIONS[0]:
    case PAN_POSITIONS[0]:
      return "modalCheckboxPosition.left"
    case SIDE_POSITIONS[1]:
    case PAN_POSITIONS[2]:
      return "modalCheckboxPosition.right"
    case PAN_POSITIONS[1]:
      return "modalCheckboxPosition.center"
  }
  return ""
};

const NavItemPositionModalButton = (props) => {

  const {position, parent, checkboxesUpdated, updateCheckboxes, changeMessageBoxState, intl, updateCanvasCount,
    activeFeature} = props;
  const [checked, setChecked] = useState(false);
  const positionName = getPositionName(position);

  const updateChecked = () => {
    const matchingPositionFeature = parent.getMatchingPositionFeature(position, activeFeature);
    const isChecked = parent.oneLayerPosition
      ? !parent.disabled && (parent.activeFeature && (parent.activeFeature.dbFeature.metaData["layerPosition"] === position))
      && matchingPositionFeature && (matchingPositionFeature.getSplittedFeatureName() === parent.activeFeature.getSplittedFeatureName())
      : !parent.disabled && parent.layerPositions && !!parent.layerPositions[position] && matchingPositionFeature
      && (matchingPositionFeature.getSplittedFeatureName() === parent.layerPositions[position].getSplittedFeatureName())

    setChecked(isChecked)
  };

  useEffect(() => {
    updateChecked();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkboxesUpdated, position, activeFeature]);

  const buttonClick = (event, fromConflictingPopup = false) => {
    if (parent.conflictingPositions && !fromConflictingPopup) { // shower_seats & valve_trim
      const conflictingPositions = parent.checkConflictingPosition(position, activeFeature);
      if (conflictingPositions.length) {
        callConflictingPopup(conflictingPositions);
        return
      }
    }
    if (parent.disabled) {
      parent.disabled = false;
      parent.disabledClick(); // disable also related parts
      if (!parent.oneLayerPosition) {
        Object.keys(parent.layerPositions).forEach(key => {
          if (key !== position) {
            parent.layerPositions[key] = null; // it can be only on one side on enable (if old feature exist and we clicked on another one)
          }
        })
      }
    }
    const matchingPositionFeature = parent.getMatchingPositionFeature(position, activeFeature);
    if (parent.oneLayerPosition) {
      matchingPositionFeature.handleClick(true); // to apply not compatible and so on // ignore locked as we it should be visible if clicked feature is unlocked
    } else {
      if (parent.isShowerCommonGroup && matchingPositionFeature && !checked) {
        if (parent.partId === "shower_arm") {
          parent.checkForSameMountPosition(matchingPositionFeature); // this removes different mount position features
        }
        matchingPositionFeature.handleClick(true); // set active feature and shower head type
      } else if (parent.partId === "shower_fixture" && matchingPositionFeature && !checked && parent.getParent().setShowerHeadType) {
        // parent.getParent().setShowerHeadType(ShowerHeadTypes.shower_fixture);
        matchingPositionFeature.handleClick(true); // set active feature and shower head type
      } else if (parent.partId === "replacement_tub_fixture" || parent.partId === "shower_head_bundle"
        || parent.partId === "hand_shower_kit") {
        matchingPositionFeature.handleClick(true); // set tub combo // ignore locked as we it should be visible if clicked feature is unlocked
      }
      parent.layerPositions[position] = checked ? null : matchingPositionFeature;
      if (parent.isShowerCommonGroup) { // tool version 6 for now only
        if (parent.partId === "shower_head") {
          parent.togglePosition(position, "shower_arm");
        } else if (parent.partId === "shower_arm") {
          parent.togglePosition(position, "shower_head");
        } else if (parent.partId === "hand_shower_only") {
          parent.togglePosition(position, "hand_shower_holder");
          parent.togglePosition(position, "shower_hose");
          parent.togglePosition(position, "wall_union");
        } else if (parent.partId === "shower_hose") {
          parent.togglePosition(position, "hand_shower_holder");
          parent.togglePosition(position, "hand_shower_only");
          parent.togglePosition(position, "wall_union");
        } else if (parent.partId === "hand_shower_holder") {
          parent.togglePosition(position, "hand_shower_only");
          parent.togglePosition(position, "shower_hose");
          parent.togglePosition(position, "wall_union");
        } else if (parent.partId === "wall_union") {
          parent.togglePosition(position, "hand_shower_only");
          parent.togglePosition(position, "shower_hose");
          parent.togglePosition(position, "hand_shower_holder");
        }
      }
        // && (!matchingPositionFeature || (parent.layerPositions[position].dbFeature.id === matchingPositionFeature.dbFeature.id))) { //already selected
    }
    // const checkRelatedFeatureGroups = ["grab_bar", "soap_dish", "shower_seats", "large_corner_seat"];
    const checkRelatedFeatureGroups = ["shower_seats", "large_corner_seat"];
    if (checkRelatedFeatureGroups.includes(parent.partId)) {
      parent.checkRelatedFeatureGroupPositions(position);
      // if (parent.partId === "grab_bar") {
      //   parent.checkCurrentPositions(position);
      // }
    }
    if (parent.partId === "grab_bar" && parent.checkCenterGrabWall) {
      parent.checkCenterGrabWall(position);
    }
    updateCheckboxes();
    $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS); // update footer items
    updateCanvasCount();
  };

  let checkboxDisabled = false;
  // if (parent.partId === "corner_shelf") { // disable top & center
  //   const windowParent = parent.getParent().layout.parts.Window;
  //   if (windowParent && windowParent.windowKits && !windowParent.windowKits.disabled && !position.includes("3")) {
  //     checkboxDisabled = true;
  //   }
  // }
  if (parent.partId === "shower_head") { // disable top & center
    const showerArm = parent.getParent().showerArm;
    if (showerArm && !showerArm.disabled && showerArm.layerPositions && !showerArm.getMatchingPositionFeature(position)) {
      // we can't use !showerArm.layerPositions[position] because if we disable in modal ope position - it becomes disabled
      checkboxDisabled = true;
    }
  }

  const callConflictingPopup = (conflictingPositions) => {
    const message = {
      id: "messageBox.metaDataMatchesFailed",
      featureGroup: activeFeature.partId === "shower_seats" ? "Seat" : activeFeature.getParent().partName,
      featureName: activeFeature.getFeatureName(),
      nonCompatibleWith: conflictingPositions[0].getParent().partName,
    };
    changeMessageBoxState({
      visible: true,
      message,
      buttons: [{
        text: "messageBox.buttonNo",
        color: "blue",
        click: () => {
          changeMessageBoxState({visible:false});
        }
      }, {
        text: "messageBox.buttonYes",
        color: 'green',
        click: () => {
          parent.applyConflictingPosition(position, activeFeature);
          buttonClick({}, true);
          changeMessageBoxState({visible:false});
        }
      }]
    })
  }

  const disabledCheckboxClick = () => {
    if (parent.partId === "corner_shelf") { // disable top & center
      const matchingPositionFeature = parent.getMatchingPositionFeature(position, activeFeature);

      const featureIsLocked = getFeatureIsLocked(matchingPositionFeature);
      if (!featureIsLocked) {
        const message = {
          id: "messageBox.metaDataMatchesFailed",
          featureGroup: matchingPositionFeature.getParent().partName,
          featureName: intl.formatMessage({id: positionName}) + " " + matchingPositionFeature.getFeatureName(),
          nonCompatibleWith: "Window Kit"
        };
        changeMessageBoxState({
          visible: true,
          message,
          buttons: [{
            text: "messageBox.buttonYes",
            color: 'green',
            click: () => {
              const windowParent = parent.getParent().layout.parts.Window;
              windowParent.windowKits.disabled = true;
              buttonClick();
              changeMessageBoxState({visible:false});
            }
          },{
            text: "messageBox.buttonNo",
            color: "blue",
            click: () => {
              changeMessageBoxState({visible:false});
            }
          }]
        });
      }
    }
  }

  return (
    <button className="ui-checkbox-wrapper" onClick={checkboxDisabled ? disabledCheckboxClick : buttonClick}>
      <span className={"ui-checkbox ui-checkbox--small"
      + (checked ? " ui-checkbox--checked" : "") + (checkboxDisabled ? " ui-checkbox--disabled" : "")}/>
      <span className={"ui-checkbox__label ui-checkbox__text" + (checkboxDisabled ? " ui-checkbox__label--disabled" : "")}>
        <FormattedMessage id={positionName}/>
      </span>
    </button>
  )
};

NavItemPositionModalButton.propTypes = {
  position: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  checkboxesUpdated: PropTypes.bool.isRequired,
  updateCheckboxes: PropTypes.func.isRequired,
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  return {
    navItemPositionModal: store.navigationState.navItemPositionModal
  };
};

const mapDispatchToProps = {
  changeMessageBoxState,
  updateCanvasCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(NavItemPositionModalButton)
)
